<div id="brand_header_banner" [innerHTML]="htmlContent"></div>
